import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

const categoryImages: Record<string, string> = {
  love: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20illustration%2C%20beautiful%20couple%20under%20cherry%20blossoms%2C%20soft%20pink%20atmosphere%2C%20romantic%20mood%2C%20clean%20simple%20composition%2C%20delicate%20digital%20art%2C%20light%20airy%20background&width=600&height=800&seq=cat-cover-love&orientation=portrait',
  suspense: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20mystery%20thriller%20illustration%2C%20detective%20silhouette%20in%20foggy%20alley%2C%20cool%20teal%20tones%2C%20suspenseful%20atmosphere%2C%20clean%20composition%2C%20dramatic%20lighting%2C%20manga%20style&width=600&height=800&seq=cat-cover-suspense&orientation=portrait',
  urban: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20modern%20city%20life%20illustration%2C%20young%20professionals%20in%20Seoul%20night%20scene%2C%20warm%20apartment%20windows%2C%20neutral%20gray%20beige%20tones%2C%20clean%20composition%2C%20slice%20of%20life%20style&width=600&height=800&seq=cat-cover-urban&orientation=portrait',
  fantasy: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20adventure%20illustration%2C%20dragon%20and%20castle%20in%20magical%20world%2C%20warm%20golden%20amber%20lighting%2C%20epic%20scale%2C%20clean%20composition%2C%20fantasy%20digital%20art&width=600&height=800&seq=cat-cover-fantasy&orientation=portrait',
};

const mainCategories = categories.slice(0, 4);

const categoryBgColors: Record<string, string> = {
  love: 'bg-accent-100/60',
  suspense: 'bg-secondary-100/60',
  urban: 'bg-background-200/70',
  fantasy: 'bg-primary-100/60',
};

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="mb-10">
          <span className="font-heading text-xs tracking-widest uppercase text-foreground-400">精选频道</span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mt-1">
            热门分类
            <span className="font-heading italic font-normal text-foreground-500 ml-2 text-xl md:text-2xl">每日更新</span>
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5">
          {mainCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`group rounded-xl overflow-hidden cursor-pointer ${categoryBgColors[cat.slug] || 'bg-background-100'}`}
            >
              <div className="aspect-[3/4] relative overflow-hidden">
                <img
                  src={categoryImages[cat.slug]}
                  alt={`${cat.name}漫画`}
                  title={`${cat.name}韩漫 - 韩漫漫画网`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="flex items-center justify-between px-4 py-3 bg-background-50">
                <div className="flex items-center gap-2">
                  <div className={`w-7 h-7 ${cat.color} rounded-full flex items-center justify-center`}>
                    <i className={`${cat.icon} ${cat.textColor} text-sm`}></i>
                  </div>
                  <span className="font-heading text-sm font-semibold text-foreground-900">{cat.name}</span>
                </div>
                <i className="ri-arrow-right-line text-foreground-400 group-hover:text-primary-500 transition-colors"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}